import { createSlice } from "@reduxjs/toolkit";
import { clearStore } from "../actions";

interface IsmartCashSlice {
  hasAccount: boolean;
  encryptionKeyObj: {
    keyId: string;
    key: string;
    validUpto: string;
  };
}

const initialState: IsmartCashSlice = {
  hasAccount: false,
  encryptionKeyObj: {
    keyId: "",
    key: "",
    validUpto: ""
  }
}

export const smartCashSlice = createSlice({
  name: "smartCashStore",
  initialState,
  reducers: {
    callFetchEncryptionKey: (state, action) => {},
    callFetchEncryptionSuccess: (state, action) => {
      state.encryptionKeyObj = action.payload;
    },
    callValidateSmartcashAccount: (state, action) => {},
    callValidateSmartcashAccountSuccess: (state, action) => {
      state.hasAccount = true;
    },
    callValidateSmartcashAccountFailure: (state, action) => {
      state.hasAccount = false;
    }
  },
  extraReducers: (builder) => {
    builder //clear home store
      .addCase(clearStore, (state) => {
        return initialState;
      })
      .addDefaultCase((state, action) => { })
  }
});

export const {
  callFetchEncryptionKey,
  callFetchEncryptionSuccess,
  callValidateSmartcashAccount,
  callValidateSmartcashAccountSuccess,
  callValidateSmartcashAccountFailure
} = smartCashSlice.actions;

export default smartCashSlice.reducer;